import { connect } from 'react-redux';
import PostForm from '../components/social/shared/share/PostForm';
import CommentForm from '../components/social/shared/share/CommentForm';
import ListTopicPosts from '../components/social/index';
import ListCommunityItems from '../components/community/ListCommunityItems';
import withAuth from '../hocs/withAuth';
import {
  createItem,
  patchItem,
  fetchList,
  fetchInfo,
  deleteItem,
  fetchTranscodedItem,
  fetchDefaultTopicBySection,
  transcodeItemStatus
} from '../store/actions/community';
import { fetch } from "../store/actions/brand";
import { showLoader, hideLoader } from '../store/actions/loader';

function mapStateToProps(state, ownProps) {
	var editId = null;
	if (ownProps.match) editId = ownProps.match.params.id;
	if (ownProps.editId) editId = ownProps.editId;
	if (ownProps.workoutId) editId = ownProps.workoutId;
	return {
		errors: state.errors,
		user: state.currentUser.user,
		editId: editId,
		...ownProps,
		brand: state.brand.detail
	};
}
const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		create: (type, parentData, childData) => {
			return dispatch(
				createItem(
					type,
					{
						...parentData,
						creatorId: ownProps.user._id
					},
					childData
				)
			);
		},
		edit: (type, parentData, childData) => {
			return dispatch(patchItem(type, parentData, childData));
		},
		fetchListData: (item) => {
			return dispatch(fetchList(item));
		},
		fetchBrand: () => {
			return dispatch(fetch());
		},
		showLoader: () => {
			return dispatch(showLoader());
		},
		hideLoader: () => {
			return dispatch(hideLoader());
		},
		fetch: (editId, type) => {
			return dispatch(fetchInfo(editId, type));
		},
		fetchSectionTopic: (section, creatorId) => {
			return dispatch(fetchDefaultTopicBySection(section, creatorId));
		},
		getTranscodeItems: (id, type, ids) => {
			return dispatch(fetchTranscodedItem(id, type, ids));
		},
		deleteItem: (id, type) => {
			return dispatch(deleteItem(id, type));
		}
	};
};

export const EditComment = withAuth(
	connect(mapStateToProps, mapDispatchToProps)(CommentForm)
);


export const EditPost = withAuth(
	connect(mapStateToProps, mapDispatchToProps)(PostForm)
);

export const TopicPosts = withAuth(
	connect(mapStateToProps, mapDispatchToProps)(ListTopicPosts)
);

export const ListItems = withAuth(
	connect(mapStateToProps, mapDispatchToProps)(ListCommunityItems)
);




// WEBPACK FOOTER //
// ./src/containers/Community.js